import script from "./RecursosDidaticosView.vue?vue&type=script&setup=true&lang=js"
export * from "./RecursosDidaticosView.vue?vue&type=script&setup=true&lang=js"

import "./RecursosDidaticosView.vue?vue&type=style&index=0&id=cc093ca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc093ca8"]])

export default __exports__